import React, { Component } from "react";
import InvestorDashboard from "components/InvestorComponents/InvestorDashboard";
import AdminDashboard from "components/AdminComponents/AdminDashboard";
import { Router } from "@reach/router";
import { LoadPanel } from "devextreme-react";
import Auth from "Api/Auth";
import { UserGroups } from "permissions/constants";
export default class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      moderator: "",
    };
    this.renderContent = () => {
      if (this.state.moderator !== "") {
        if (this.state.moderator) {
          return <AdminDashboard path="/*" />;
        } else {
          return <InvestorDashboard path="/*" />;
        }
      }
      return (
        <LoadPanel visible={true} message={"Please be patient"} path="/" />
      );
    };
  }
  componentDidMount() {
    this.setState({
      moderator: !(Auth.decodedToken().group === UserGroups.Investor),
    });
  }

  render() {
    return <Router>{this.renderContent()}</Router>;
  }
}
